import React, { useState, useEffect, useRef } from 'react';
import { Input } from 'antd';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import debounce from 'lodash/debounce';
// components
import InputField from '../../../molecules/inputField';
// actions
import therapistsAction from '../../../../redux/actions/therapists';
// types
import { stateType } from '../../../../types/types';
// styles
import '../style.scss';
// icons
import Icon from '@ant-design/icons';
import { ReactComponent as SearchIcon } from '../../../../assets/image/inputs/search.svg';

const SearchTherapists: React.FC = () => {
  const [focus, setState] = useState(false);
  const dispatch = useDispatch();
  const inputField: any = useRef(null);
  const params: any = useSelector((state: stateType) => state.therapists.params, shallowEqual);
  const loader = useSelector((state: stateType) => state.therapists.loader, shallowEqual);

  useEffect(() => {
    if (focus) {
      !loader && inputField.current.focus();
    }
  }, [loader]);

  const onChange = async (e: any) => {
    try {
      await therapistsAction.params({ ...params, name: e.target.value.trim(), page: 1 });
      dispatch(therapistsAction.get());
    } catch (e) {
      console.log(e);
    }
  };

  const onFocus = () => {
    setState(true);
  };
  return (
    <div className="search-clients-field">
      <InputField>
        <Input
          prefix={<Icon component={SearchIcon} style={{ fontSize: 24, color: '#92929D' }} />}
          defaultValue={params.name ? params.name : ''}
          onFocus={onFocus}
          ref={inputField}
          disabled={loader}
          placeholder="Search therapists here..."
          className="search-clients-field__input"
          onChange={debounce(onChange, 600)}
        />
      </InputField>
    </div>
  );
};

export default SearchTherapists;
